module.exports = __webpack_public_path__ + "static/media/C (6).fb9755a2.jpg";